/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillingFrequency } from './BillingFrequency';
import {
    BillingFrequencyFromJSON,
    BillingFrequencyFromJSONTyped,
    BillingFrequencyToJSON,
    BillingFrequencyToJSONTyped,
} from './BillingFrequency';

/**
 * 
 * @export
 * @interface UpdateCalculationCycleRequest
 */
export interface UpdateCalculationCycleRequest {
    /**
     * 
     * @type {Date}
     * @memberof UpdateCalculationCycleRequest
     */
    cycleDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdateCalculationCycleRequest
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdateCalculationCycleRequest
     */
    endDate: Date;
    /**
     * 
     * @type {BillingFrequency}
     * @memberof UpdateCalculationCycleRequest
     */
    billingFrequency: BillingFrequency;
    /**
     * 
     * @type {string}
     * @memberof UpdateCalculationCycleRequest
     */
    description?: string | null;
}



/**
 * Check if a given object implements the UpdateCalculationCycleRequest interface.
 */
export function instanceOfUpdateCalculationCycleRequest(value: object): value is UpdateCalculationCycleRequest {
    if (!('cycleDate' in value) || value['cycleDate'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('billingFrequency' in value) || value['billingFrequency'] === undefined) return false;
    return true;
}

export function UpdateCalculationCycleRequestFromJSON(json: any): UpdateCalculationCycleRequest {
    return UpdateCalculationCycleRequestFromJSONTyped(json, false);
}

export function UpdateCalculationCycleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCalculationCycleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'cycleDate': (new Date(json['cycleDate'])),
        'startDate': (new Date(json['startDate'])),
        'endDate': (new Date(json['endDate'])),
        'billingFrequency': BillingFrequencyFromJSON(json['billingFrequency']),
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function UpdateCalculationCycleRequestToJSON(json: any): UpdateCalculationCycleRequest {
    return UpdateCalculationCycleRequestToJSONTyped(json, false);
}

export function UpdateCalculationCycleRequestToJSONTyped(value?: UpdateCalculationCycleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cycleDate': value['cycleDate'].toISOString().substring(0,10),
        'startDate': value['startDate'].toISOString().substring(0,10),
        'endDate': value['endDate'].toISOString().substring(0,10),
        'billingFrequency': BillingFrequencyToJSON(value['billingFrequency']),
        'description': value['description'],
    };
}

